import X from '@/assets/icons/X.svg';
import { IconButton } from '@/components/IconButton';
import { ImageLink } from '@/components/ImageLink';
import { useCloseMenu } from './MenuToggle';
import * as Styled from './MenuToggle.styled';

export const MenuHeader = () => {
  const closeMenu = useCloseMenu();

  return (
    <Styled.MenuHeader>
      <ImageLink href="/" label="Go to Easons homepage">
        <img
          alt="Easons logo"
          height={28}
          width={133}
          src="/Styles/Images/eason-logo.png"
        />
      </ImageLink>
      <IconButton
        handler={closeMenu}
        icon={<X />}
        label="Close menu"
        width={24}
      />
    </Styled.MenuHeader>
  );
};
